import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=151ce962&scoped=true"
import script from "./DocumentDetail.vue?vue&type=script&lang=js"
export * from "./DocumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ce962",
  null
  
)

export default component.exports